import React from 'react';

function Profile() {
  return (
    <div className="body" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <h1 style={{ paddingTop: '140px', marginTop: 0 }}>Profile</h1>
      <p>View your BeanBonus profile, track your rewards, and manage your account settings.</p>
      {/* Add more content as needed */}
    </div>
  );
}

export default Profile;